<template>
	<b-container class="w-75 text-dark">
		<b-row class="heading mh-100 m-0 p-0" style="height: 100%; max-height: 100%;" align-v="center" v-if="clientKey">
			<transition name="fade" key="transition.demo.index" appear>
			<b-col class="m-0 p-0 text-center">
				<template v-if="email">
					<RingLoader :color="'#343a40'" :size="64" :loading="true" class="m-auto py-5" />
					<template v-if="!isValidEmail">
			         	Validating address ...
					</template>
					<template v-if="isValidEmail && !token">
			         	Creating your desktop ...
					</template>
					<template v-if="token && $asyncComputed.isValidToken.updating">
						Creating your desktop ...
					</template>
					<template v-if="$asyncComputed.isValidToken.success && isValidToken && !streamingURL">
						Generating link to desktop ...
					</template>
					<template v-if="$asyncComputed.streamingURL.success && streamingURL">
						Redirecting to desktop. Click <a :href="streamingURL">here</a> if you are not redirected in a few seconds.
					</template>
				</template>
<!-- 
				<ErrorModal :modalData="{ message: 'Token appears to be missing or invalid.', visible: true, allowClose: false }" v-else-if="!token || !isValidToken" />
 -->
				<ErrorModal :modalData="{ message: 'Invalid email address.', visible: true, allowClose: false }" v-if="!!email && isValidEmail === false" />
			</b-col>
			</transition>
		</b-row>
	</b-container>
</template>

<script>
	import { mapMutations, mapState } from 'vuex';
	
	import Launch from '@/components/VirtApp/Launch';
	import { RingLoader } from '@saeris/vue-spinners';
	
	const { DNSoverHTTPS } = require('dohdec');
	const doh = new DNSoverHTTPS();
	
	const { parseOneAddress } = require('email-addresses');
	
	export default
	{
		name: 'demo',
		components: { Launch, RingLoader },
		asyncComputed:
		{
			virtapps:
			{
				lazy: true,
				async get()
				{
					if(!this.token)
						return [];
					
					let virtapps = await this.portalAPI.get('/virtapp', { headers: { eLuminAuthToken: this.token } })
						.then(
							resp => Promise.resolve(resp.data),
							err => Promise.reject(this.$logger.error(err))
						);
					
					this.$logger.debug('User virtapps loaded', virtapps);
					
					return Promise.resolve(virtapps);
				},
				async shouldUpdate()
				{
					return (!!this.token && (await this.isValidToken === true));
				}
			},
			isValidToken:
			{
				lazy: true,
				async get()
				{
					return !!this.token && !!await this.portalAPI.post('/demo/token/validate', undefined, { headers: { eLuminAuthToken: this.token } })
						.then(
							resp => Promise.resolve(resp.data),
							err => this.$logger.error(err)
						);
				},
				default: false
			},
			streamingURL:
			{
				lazy: true,
				async get()
				{
					if(this.$asyncComputed.isValidToken.success && this.isValidToken)
					{
						let result = await this.portalAPI.get(
								'/virtapp/' + process.env.VUE_APP_DEMO_STACK_UUID + '/link',
								{ headers: { eLuminAuthToken: this.token }, params: { app: 'Desktop' } }
							)
							.then(
								resp => Promise.resolve(resp.data)
							).catch(e => this.$logger.error(e));
				
						this.$logger.debug(result);
						
						if('StreamingURL' in result)
						{
							let u = new URL(result.StreamingURL);
							
							u.hostname = 'virtlab.elumin.co';
							
							return Promise.resolve(u.toString());
						}
					}
					
					return undefined;
				},
				async shouldUpdate()
				{
					return (this.isValidToken === true);
				}
			},
		},
		computed:
		{
			...mapState([ 'clientKey', 'clientConfig', 'authSession', 'userSession', 'profile', 'loadedAt' ]),
			portalAPI: function()
			{
				return this.$root.$refs.app.portalAPI;
			}
		},
		watch:
		{
			email: async function(nVal)
			{
				let parsedEmail = parseOneAddress(nVal);
				
				this.isValidEmail = (!!parsedEmail && !!parsedEmail.domain && 
					!!(await doh.lookup({ name: parsedEmail.domain, rrtype: 'MX' }).then(resp => resp.Answer))
				);
				
				if(this.isValidEmail && ('clientCode' in this.clientConfig))
					this.token = await this.getToken(nVal);
				
			},
			token: async function(nVal)
			{
				const decodedToken = this.$jwt.decode(nVal);
				
				if(('aud' in decodedToken))
				{
					this.$logger.debug('Found clientKey: ' + decodedToken.aud);
					
					this.$store.dispatch('clientKey', decodedToken.aud);
				}
				
				if(('sub' in decodedToken))
				{
					this.$store.dispatch(
						'profile',
						Object.assign(
							{
								uuid: 1,
								institution: { name: ((this.clientConfig && ('name' in this.clientConfig)) ? this.clientConfig.name : ' ' ) }
							},
							(({ firstName, lastName, sub }) => ({ firstName, lastName, email: sub }))(decodedToken)
						)
					);
				}
			},
			clientConfig: async function(nVal, oVal)
			{
				if(nVal && this.profile)
				{
					this.$store.dispatch(
						'profile',
						Object.assign(this.profile || {}, { institution: { name: nVal.name } })
					)
				}

				if(this.isValidEmail && !this.token)
					this.token = await this.getToken(this.email);
			},
			streamingURL: function(nVal, oVal)
			{
				if(nVal)
					this.$timer.start('launch');
			}
		},
		timers:
		{
			launch:
			{
				callback: function()
				{
					if(!!this.streamingURL && (!('autostart' in this.$route.query) || Boolean(this.$route.query.autostart)))
					{
						this.$logger.debug('Redirect to: ' + this.streamingURL);
						
						window.location = this.streamingURL;
					}
				},
				autostart: false,
				repeat: false,
				immediate: false,
				time: 1000 * 1
			}
		},
		methods:
		{
			getToken: async function(email)
			{
				return await this.portalAPI.post('/demo/token/create', { email })
					.then(
						resp => Promise.resolve(resp.data),
						err => this.$logger.error(err)
					);
			},
			showError: function(message) { return this.$root.$refs.app.showError(message); }
		},
		async created()
		{
			await this.$store.dispatch('clear');
			
			if(this.$route.query.email)
				this.email = this.$route.query.email;
				
			if(this.$route.query.token)
				this.token = this.$route.query.token;
			
			if(!this.clientKey)
			{
				this.$nextTick(
					function()
					{
						vm.$store.dispatch('clientKey', '26Lm0nnpoMET4xlbGmRFca');
					}
				);
			}
		},
		mounted()
		{
		},
		data() { return { email: undefined, isValidEmail: undefined, token: undefined }; }
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	.container
	{
		height: 100%;
		max-height: 100%;
		
		overflow: auto;
		
		padding: 12px;
	}
	
	.fade-enter-active, .fade-leave-active
	{
		transition: all 1s;
	}
</style>

